// Client-side detection of the ai_tokens_exhausted 429 that metered
// edge functions return when a profile's weekly AI allowance is used
// up (migration 0279, docs/AI_TOKENS.md). supabase.functions.invoke
// surfaces non-2xx as a FunctionsHttpError whose `context` is the raw
// Response — the body has to be read off it explicitly.

export async function readAiTokenDenial(invokeError, data) {
  if (data?.error === "ai_tokens_exhausted") return data;
  const ctx = invokeError?.context;
  if (ctx && ctx.status === 429 && typeof ctx.clone === "function") {
    try {
      const body = await ctx.clone().json();
      if (body?.error === "ai_tokens_exhausted") return body;
    } catch { /* not a JSON body — fall through */ }
  }
  return null;
}

// Kid-facing copy — warm, blame-free, and honest about the reset.
export const KID_TOKENS_MESSAGE =
  "The magic is all used up for this week — it comes back Monday!";

// Adult-facing copy for non-kid surfaces.
export const TOKENS_MESSAGE =
  "Weekly AI allowance is used up — it resets Monday.";
